import { render, staticRenderFns } from "./VerticalNavMenuDivider.vue?vue&type=template&id=721a05c2"
import script from "./VerticalNavMenuDivider.vue?vue&type=script&lang=js"
export * from "./VerticalNavMenuDivider.vue?vue&type=script&lang=js"
import style0 from "./VerticalNavMenuDivider.vue?vue&type=style&index=0&id=721a05c2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports